import { render, staticRenderFns } from "./Suntech300.vue?vue&type=template&id=47ddd0d5"
import script from "./Suntech300.vue?vue&type=script&lang=js"
export * from "./Suntech300.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports